(function () {
  const header = document.querySelector('.header'); // adjust selector to match your theme
  const startColor = { r: 255, g: 255, b: 255 };   // white
  const endColor = { r: 191, g: 192, b: 232 }; // #BFC0E8

  function lerp(a, b, t) { return Math.round(a + (b - a) * t); }

  window.addEventListener('scroll', () => {
    const t = Math.min(window.scrollY / (document.body.scrollHeight - window.innerHeight), 1);
    const r = lerp(startColor.r, endColor.r, t);
    const g = lerp(startColor.g, endColor.g, t);
    const b = lerp(startColor.b, endColor.b, t);
    header.style.backgroundColor = `rgb(${r},${g},${b})`;
  }, { passive: true });
})();

